/* Triple Collection Panels: mouse click-drag scrolling + Flash Sale countdown. */
(function () {
  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  /* Touch, trackpad and wheel already pan the row natively; a mouse doesn't.
     Mirrors the shim in tmg-collection-swiper.js. */
  function initDrag(root) {
    var scroller = root.querySelector('[data-ttp-scroller]');
    if (!scroller) return;

    var down = false;
    var moved = false;
    var startX = 0;
    var startLeft = 0;

    scroller.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      if (scroller.scrollWidth <= scroller.clientWidth) return;
      down = true;
      moved = false;
      startX = e.clientX;
      startLeft = scroller.scrollLeft;
      scroller.classList.add('is-dragging');
    });

    scroller.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 3) moved = true;
      scroller.scrollLeft = startLeft - dx;
    });

    function endDrag() {
      if (!down) return;
      down = false;
      scroller.classList.remove('is-dragging');
    }

    scroller.addEventListener('pointerup', endDrag);
    scroller.addEventListener('pointercancel', endDrag);
    scroller.addEventListener('pointerleave', endDrag);

    /* Swallow the click that ends a drag, so releasing over a panel doesn't
       open the product behind it. */
    scroller.addEventListener('click', function (e) {
      if (!moved) return;
      e.preventDefault();
      e.stopPropagation();
      moved = false;
    }, true);
  }

  function initCountdown(panel) {
    var startsAt = parseInt(panel.getAttribute('data-starts-at'), 10) * 1000;
    var forced = panel.getAttribute('data-forced') === 'true';
    var days = panel.querySelector('[data-ttp-days]');
    var hours = panel.querySelector('[data-ttp-hours]');
    var minutes = panel.querySelector('[data-ttp-minutes]');
    var seconds = panel.querySelector('[data-ttp-seconds]');
    if (!startsAt || !days || !hours || !minutes || !seconds) return;

    var timerId = setInterval(tick, 1000);

    function tick() {
      if (!panel.isConnected) {
        clearInterval(timerId);
        return;
      }

      var left = Math.floor((startsAt - Date.now()) / 1000);

      if (left <= 0) {
        clearInterval(timerId);
        /* The sale opened while the page sat open — the Flash Sale (Weekly)
           section owns the day from here, so retire the panel. */
        if (!forced) panel.remove();
        return;
      }

      days.textContent = pad(Math.floor(left / 86400));
      hours.textContent = pad(Math.floor((left % 86400) / 3600));
      minutes.textContent = pad(Math.floor((left % 3600) / 60));
      seconds.textContent = pad(left % 60);
    }

    tick();
  }

  function init(root) {
    initDrag(root);
    var flash = root.querySelector('[data-ttp-flash]');
    if (flash) initCountdown(flash);
  }

  Array.prototype.forEach.call(document.querySelectorAll('[data-ttp]'), init);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-ttp]');
    if (root) init(root);
  });
})();
